import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import success from "../../assets/lottie/success.json";

interface IProps {
  height?: string;
  width?: string;
  onComplete: () => void;
  msg?: string;
}

const SuccessAnimation = ({
  height = "300px",
  width = "300px",
  onComplete,
  msg = "Success",
}: IProps) => {
  return (
    <div className="mt-40" data-cy="successAnimation">
      <Player
        autoplay
        keepLastFrame
        onEvent={(event) => {
          if (event === "complete") onComplete();
        }}
        speed={0.75}
        src={success}
        style={{ height, width }}
      />
      <h2
        data-cy="successAnimationMessage"
        className="mt-16"
        style={{ textAlign: "center" }}
      >
        {msg}
      </h2>
    </div>
  );
};

export default SuccessAnimation;
